<template>
  <div>
    <v-container>
      <v-btn
        depressed
        :outline="graphtype != 'user'"
        :color="graphtype == 'user' ? 'primary' : 'grey'"
        @click="graphtype = 'user'"
      >
        {{ $t('User') }}
      </v-btn>
      <v-btn
        depressed
        :outline="graphtype != 'message'"
        :color="graphtype == 'message' ? 'primary' : 'grey'"
        @click="graphtype = 'message'"
      >
        {{ $t('Message') }}
      </v-btn>
    </v-container>
    <v-divider />
    <template v-if="type == 'comment'">
      <v-container>
        <select-page-post
          v-model="selectedPost"
          @resetSelectPost="resetSelectPost"
          @changePost="onChangePost"
        ></select-page-post>
      </v-container>
      <v-divider></v-divider>
    </template>
    <v-container v-if="type == 'inbox' || type == 'comment'">
      <v-layout>
        <v-flex>
          <select-channel
            v-model="app"
            :channels="
              type == 'comment'
                ? ['all', 'facebook', 'instagram']
                : ['all', 'facebook', 'line', 'instagram', 'google']
            "
          />
        </v-flex>
        <v-flex shrink>
          <v-btn
            v-if="$store.getters.getPackage != 'premium'"
            outline
            color="grey"
            class="ma-0 mb-1"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
            <v-premium-lock
              text="Bring the data to excel for analysis. Upgrade to Premium onwards, starting at 500 baht/month."
            ></v-premium-lock>
          </v-btn>
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            :loading="
              (graphtype == 'user' && !dataExportDate && !dataExportTime) ||
              (graphtype == 'message' && !dataExportMessage)
            "
            color="primary"
            outline
            class="ma-0 mb-1"
            @click="exportdata(graphtype)"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <date-filter v-model="selectedDate" :default-filter="'last_7_days'"></date-filter>

      <template v-if="graphtype == 'user'">
        <report-user-by-date
          :key="`report-user-by-date_${timestamp}`"
          v-model="dataExportDate"
          :type="type"
          :date="selectedDate"
          :app="app"
          :fbpost="selectedPost"
        ></report-user-by-date>

        <report-user-by-time
          :key="`report-user-by-time_${timestamp}`"
          v-model="dataExportTime"
          :type="type"
          :date="selectedDate"
          :app="app"
          :fbpost="selectedPost"
        ></report-user-by-time>
      </template>
      <template v-else-if="graphtype == 'message'">
        <report-message
          :key="`report-message_${timestamp}`"
          v-model="dataExportMessage"
          :type="type"
          :date="selectedDate"
          :app="app"
          :fbpost="selectedPost"
        ></report-message>
      </template>
    </v-container>
  </div>
</template>

<script>
import SelectChannel from '../SelectChannel'
import DateFilter from '../DateFilter'
import moment from 'moment'
import ReportUserByDate from './ReportUserByDate'
import ReportUserByTime from './ReportUserByTime'
import ReportMessage from './ReportMessage'
import SelectPagePost from '../SelectPagePost'
import XLSX from 'xlsx'
import { mapGetters } from 'vuex'

export default {
  components: {
    SelectChannel,
    DateFilter,
    ReportUserByDate,
    ReportUserByTime,
    ReportMessage,
    SelectPagePost
  },
  props: ['type'],
  data() {
    return {
      graphtype: 'user',
      selectedPost: null,
      app: 'all',
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      timestamp: moment().format('x'),
      dataExportDate: null,
      dataExportTime: null,
      dataExportMessage: null
    }
  },
  computed: {
    ...mapGetters({
      reportInboxMessage: 'getReportInboxMessage',
      reportReplyToComment: 'getReportReplyToComment',
      reportReplyToInbox: 'getReportReplyToInbox',
      reportHideToComment: 'getReportHideToComment'
    })
  },
  methods: {
    onChangePost() {
      this.timestamp = moment().format('x')
    },
    resetSelectPost() {
      this.selectedPost = null
      this.onChangePost()
    },
    exportdata(graphtype) {
      let json = []
      let timeData = []
      let name = 'notitle'
      const wb = XLSX.utils.book_new()
      if (this.type === 'inbox') {
        if (graphtype === 'message') {
          name = 'inbox-message.xlsx'
          json =
            this.dataExportMessage[0].intents && this.dataExportMessage[0].intents.length
              ? this.dataExportMessage[0].intents.map((el) => ({ name: el.name, count: el.value }))
              : []
          const ws = XLSX.utils.json_to_sheet(json)
          wb.SheetNames.push('inbox-message')
          wb.Sheets['inbox-message'] = ws
        } else if (graphtype === 'user') {
          Object.keys(this.dataExportTime[0]).map((item) => {
            timeData.push({ time: item, message: this.dataExportTime[0][item] })
          })
          json = this.dataExportDate
          name = 'inbox-user.xlsx'

          wb.SheetNames.push('export-by-date')
          wb.SheetNames.push('exprot-by-time')
          const ws = XLSX.utils.json_to_sheet(json)
          const ws2 = XLSX.utils.json_to_sheet(timeData)
          wb.Sheets['export-by-date'] = ws
          wb.Sheets['exprot-by-time'] = ws2
        }
      } else if (this.type === 'comment') {
        if (graphtype === 'message') {
          console.log(this.dataExportMessage)
          name = 'comment-message.xlsx'
          wb.SheetNames.push('reply-to-date')
          wb.SheetNames.push('reply-to-inbox')
          wb.SheetNames.push('hide-to-comment')
          const ws = XLSX.utils.json_to_sheet(
            this.dataExportMessage[0].intents && this.dataExportMessage[0].intents.length
              ? this.dataExportMessage[0].intents.map((el) => ({ name: el.name, count: el.value }))
              : []
          )
          const ws2 = XLSX.utils.json_to_sheet(
            this.dataExportMessage[1].intents && this.dataExportMessage[1].intents.length
              ? this.dataExportMessage[1].intents.map((el) => ({ name: el.name, count: el.value }))
              : []
          )
          const ws3 = XLSX.utils.json_to_sheet(
            this.dataExportMessage[2].intents && this.dataExportMessage[2].intents.length
              ? this.dataExportMessage[2].intents.map((el) => ({ name: el.name, count: el.value }))
              : []
          )
          wb.Sheets['reply-to-date'] = ws
          wb.Sheets['reply-to-inbox'] = ws2
          wb.Sheets['hide-to-comment'] = ws3
        } else if (graphtype === 'user') {
          Object.keys(this.dataExportTime[0]).map((item) => {
            timeData.push({ time: item, message: this.dataExportTime[0][item] })
          })
          json = this.dataExportDate
          name = 'comment-user.xlsx'
          wb.SheetNames.push('export-by-date')
          wb.SheetNames.push('exprot-by-time')
          const ws = XLSX.utils.json_to_sheet(json)
          const ws2 = XLSX.utils.json_to_sheet(timeData)
          wb.Sheets['export-by-date'] = ws
          wb.Sheets['exprot-by-time'] = ws2
        }
      }
      XLSX.writeFile(wb, name)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/report/ReportConversation.vue